// extracted by mini-css-extract-plugin
export default {"heading":"Targeting_heading__fBGah","wrapper":"Targeting_wrapper__y8c-w"};